import { render } from "./ModalAbrirChamado.vue?vue&type=template&id=651404e2&scoped=true"
import script from "./ModalAbrirChamado.vue?vue&type=script&lang=js"
export * from "./ModalAbrirChamado.vue?vue&type=script&lang=js"

import "./ModalAbrirChamado.vue?vue&type=style&index=0&id=651404e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651404e2"]])

export default __exports__